<template>
  <v-row>
    <v-col cols="12">
      <!-- Sayfa başlığı: diğer ekranlarla aynı `ec-header` bloğu -->
      <div class="ec-header">
        <div class="ec-header__left">
          <div class="ec-header__icon">
            <v-icon size="22">mdi-tag</v-icon>
          </div>
          <div>
            <h1 class="ec-header__title">Version Management</h1>
            <p class="ec-header__subtitle">Client, engine and service release versions</p>
          </div>
        </div>
      </div>
    </v-col>
    <v-col md="12" lg="3">
      <v-navigation-drawer width="100%" permanent>
        <v-list nav class="pl-0">
          <v-list-item-group v-model="item" color="primary">
            <v-list-item
              v-for="(item, i) in items"
              :key="i"
              @click="$router.push('/version-management/' + item.path)"
            >
              <v-list-item-icon class="mr-3">
                <v-icon>{{item.icon}}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="lato-bold font-16">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
    </v-col>
    <v-col md="12" lg="9">
      <router-view></router-view>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'versionManagement',
  data: () => ({
    item: 0,
    items: [
      {
        title: 'Client Version',
        path: 'client-version',
        icon: 'mdi-laptop'
      },
      {
        title: 'Stream Engine Version',
        path: 'stream-engine-version',
        icon: 'mdi-alpha-s-box-outline'
      },
      {
        title: 'Inference Engine Version',
        path: 'inference-engine-version',
        icon: 'mdi-alpha-i-box-outline'
      },
      {
        title: 'COSSA Version',
        path: 'cossa-version',
        icon: 'mdi-alpha-c-box-outline'
      },
      {
        title: 'Onvif Discovery Version',
        path: 'onvif-discovery-version',
        icon: 'mdi-alpha-o-box-outline'
      }
    ]
  })
}
</script>

<style scoped>
</style>
